import { Injectable, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { map } from 'rxjs';

import { AuthService } from '../../features/auth/services/auth.service';
import { NotificacionAppService } from './notificacion-app.service';
import { PageTitleService } from './page-title.service';

/**
 * Lleva el título de la pestaña al navegador: toma lo que dicen los encabezados ({@link PageTitleService}), le suma la
 * empresa de la sesión y las notificaciones sin leer, y lo escribe en {@code document.title}. Lo instancia solo el
 * componente raíz; las pantallas y sus pruebas no cargan con la sesión ni con HTTP.
 */
@Injectable({ providedIn: 'root' })
export class PestanaDelNavegador {
  private title = inject(Title);
  private auth = inject(AuthService);
  private notificaciones = inject(NotificacionAppService);
  private titulos = inject(PageTitleService);

  private readonly empresa = toSignal(
    this.auth.currentUser$.pipe(map(u => (u?.empresaNombre as string | undefined) ?? null)), { initialValue: null });
  private readonly noLeidas = toSignal(this.notificaciones.getCantidadNoLeidas(), { initialValue: 0 });

  constructor() {
    effect(() => {
      this.titulos.empresa.set(this.empresa());
      this.titulos.noLeidas.set(this.noLeidas());
    });
    effect(() => this.title.setTitle(this.titulos.texto()));
  }
}
